// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2FQ0D","unreadBadge":"styles_unreadBadge__37q0U","modalContent":"styles_modalContent__HeyEi","modal":"styles_modal__3hww6"};